export default "__VITE_ASSET__BmnAzoV6__"